import React from 'react';

export const Dashboard = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.41667 16.25V20.5833H9.75V16.25H5.41667ZM4.33333 14.0833C3.73502 14.0833 3.25 14.5684 3.25 15.1667V21.6667C3.25 22.265 3.73502 22.75 4.33333 22.75H10.8333C11.4316 22.75 11.9167 22.265 11.9167 21.6667V15.1667C11.9167 14.5684 11.4316 14.0833 10.8333 14.0833H4.33333Z"
      fill={color ?? '#5D54C0'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.41667 5.41661V9.74994H9.75V5.41661H5.41667ZM4.33333 3.24994C3.73502 3.24994 3.25 3.73496 3.25 4.33327V10.8333C3.25 11.4316 3.73502 11.9166 4.33333 11.9166H10.8333C11.4316 11.9166 11.9167 11.4316 11.9167 10.8333V4.33327C11.9167 3.73496 11.4316 3.24994 10.8333 3.24994H4.33333Z"
      fill={color ?? '#5D54C0'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2499 16.25V20.5833H20.5833V16.25H16.2499ZM15.1666 14.0833C14.5683 14.0833 14.0833 14.5684 14.0833 15.1667V21.6667C14.0833 22.265 14.5683 22.75 15.1666 22.75H21.6666C22.2649 22.75 22.7499 22.265 22.7499 21.6667V15.1667C22.7499 14.5684 22.2649 14.0833 21.6666 14.0833H15.1666Z"
      fill={color ?? '#5D54C0'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4165 5.23071L16.1184 7.52881L18.4165 9.8269L20.7146 7.52881L18.4165 5.23071ZM19.1825 2.93261C18.7595 2.50954 18.0735 2.50954 17.6505 2.93261L13.8203 6.76277C13.3972 7.18584 13.3972 7.87177 13.8203 8.29484L17.6505 12.125C18.0735 12.5481 18.7595 12.5481 19.1825 12.125L23.0127 8.29484C23.4358 7.87177 23.4358 7.18584 23.0127 6.76277L19.1825 2.93261Z"
      fill={color ?? '#5D54C0'}
    />
  </svg>
);
